import { selector } from "@store/Framework/Store/Store/Components/RenderIfNeeded/selector";
import { useSelector } from "react-redux";

export const useCurrentPage = () => {
    return useSelector(selector);
};
